export default __webpack_public_path__ + "static/media/portfolio-hover-166.93c96a20.jpg";